import { _, am5, am5xy } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

export const createSeries = ({
  root,
  chart,
  data,
  xAxis,
  yAxis,
  xAxisField,
  yAxisField,
  heatMinValue,
  heatMaxValue,
  minColor,
  maxColor,
  labelValues,
  hideHeatLegend,
  heatLegend,
  fullScreen,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  data: types.widgets.TableData;
  xAxis: am5xy.CategoryAxis<am5xy.AxisRenderer>;
  yAxis: am5xy.CategoryAxis<am5xy.AxisRenderer>;
  xAxisField: string;
  yAxisField: string;
  heatMinValue: number;
  heatMaxValue: number;
  minColor: string;
  maxColor: string;
  labelValues: boolean;
  hideHeatLegend: boolean;
  heatLegend: am5.HeatLegend;
  fullScreen: boolean;
}) => {
  const series = chart.series.push(
    am5xy.ColumnSeries.new(root, {
      calculateAggregates: true,
      stroke: am5.color(0xffffff),
      clustered: false,
      xAxis: xAxis,
      yAxis: yAxis,
      categoryXField: xAxisField,
      sequencedInterpolation: true,
      categoryYField: yAxisField,
      valueField: 'value',
      valueXField: 'heatValue',
    })
  );

  series.columns.template.setAll({
    tooltipText: `{${xAxisField}}, {${yAxisField}}: {value}`,
    strokeOpacity: 1,
    strokeWidth: 2,
    width: am5.percent(100),
    height: am5.percent(100),
  });

  series.set('heatRules', [
    {
      target: series.columns.template,
      key: 'fill',
      dataField: _.isEmpty(data) ? '' : 'heatValue' in data[0] ? 'valueX' : 'value',
      minValue: heatMinValue,
      maxValue: heatMaxValue,
      min: am5.color(minColor),
      max: am5.color(maxColor),
    },
  ]);

  if (!hideHeatLegend) {
    series.columns.template.events.on('pointerover', function (event) {
      heatLegend.showValue(event.target.dataItem.get('value' as any) as number);
    });

    series.columns.template.events.on('pointerout', function () {
      heatLegend.hideTooltip();
    });
  }

  if (labelValues) {
    series.bullets.push(function () {
      return am5.Bullet.new(root, {
        sprite: am5.Label.new(root, {
          text: '{value}',
          centerX: am5.percent(50),
          centerY: am5.percent(50),
          populateText: true,
          fill: am5.color('#fff'),
          fontSize: fullScreen ? '0.9rem' : '0.7rem',
          fontWeight: '600',
          shadowColor: am5.color('#000'),
          shadowBlur: 3,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
        }),
      });
    });
  }

  series.data.setAll(data);
};
